import { CobuStack, CobuText } from '@cobu/ui'
import { Strings } from '../../constants'

export default function DeactivatedAccountScreen() {
  const strings = Strings.get()
  const title = strings.auth.deactivatedUser.title
  const mainText = strings.auth.deactivatedUser.mainText
  const description = strings.auth.deactivatedUser.description
  const email = strings.auth.deactivatedUser.supportEmail
  const emailSubject = strings.auth.deactivatedUser.emailSubject

  const handleEmailPress = () => {
    const subject = encodeURIComponent(emailSubject)
    window.location.href = `mailto:${email}?subject=${subject}`
  }

  return (
    <CobuStack f={1} bg="$white" ai="center">
      <CobuStack f={1} jc="center" w="90%" >
        <CobuStack bg="$white" pt="$6" pb="$6" px="$8" br="$2" gap="$6">
          <CobuText variant="subheading" fow="$semibold" ta="center" mt="$0" pt="$0">
            {title}
          </CobuText>

          <CobuText variant="body" color="$color" ta="center">
            {mainText}
          </CobuText>

          <CobuText variant="body" color="$colorMuted" ta="center">
            {description}
          </CobuText>

          <CobuText
            variant="body"
            ta="center"
            onPress={handleEmailPress}
            fontWeight="bold"
          >
            {email}
          </CobuText>
        </CobuStack>
      </CobuStack>
    </CobuStack>
  )
}


